import {Component, EventEmitter, HostListener, Input, OnInit, Output} from "@angular/core";
import {ImporterDto, ManufacturerData, TemplateDto, TemplatePartyDto, TemplateSubmisionRequest}
	from "../../shipper";
import {CommonModule} from "@angular/common";
import {NgbAccordionBody, NgbAccordionButton, NgbAccordionCollapse, NgbAccordionDirective, NgbAccordionHeader, NgbAccordionItem}
	from "@ng-bootstrap/ng-bootstrap";


@Component({
	selector: 'isf-parties',
	standalone: true,
	imports: [
		CommonModule,
		NgbAccordionBody,
		NgbAccordionButton,
		NgbAccordionCollapse,
		NgbAccordionDirective,
		NgbAccordionHeader,
		NgbAccordionItem,
	],
	template: `
		
		<div>

			<div ngbAccordion #accordion="ngbAccordion" [closeOthers]="false" [destroyOnHide]="false" >
				<div ngbAccordionItem [collapsed]="partyHeaderCollapse">
					
                    <h2 ngbAccordionHeader>
                        <button ngbAccordionButton class="p-0">
                            <div class="input-group">
                                <div class="template-header p-1 mb-1 w-100">
									
									<div class="container-fluid">
										<div class="row p-1">
											<div class="col-4">
                                                <span class="acc-header">Template:</span>
												<span class="acc-value">{{template.name}}</span>
											</div>
                                            <div class="col-4">
                                                <span class="acc-header">Warehouse (ST):</span>
                                                <span class="acc-value">{{template.warehouse.name}}</span>
											</div>
                                            <div class="col-4">
                                                <span class="acc-header">Created:</span>
                                                <span class="acc-value">{{template.createdAt | date:'mediumDate'}}</span>
											</div>
										</div>
									</div>
									
									<!--
                                    <table class="table table-borderless p-0 m-0">
                                        <tbody>
                                        <tr>
                                            <th style="width: 10px;">Template:</th>
                                            <td class="">{{template.name}}</td>
                                            <th style="width: 145px;">Warehouse (ST):</th>
                                            <td>{{template.warehouse.name}}</td>
											<th style="width: 10px;">Created:</th>
                                            <td>{{template.createdAt | date:'mediumDate'}}</td>
											
                                        </tr>
                                        </tbody>
                                    </table>
                                    -->
                                </div>
                            </div>
                        </button>
                    </h2>


                    <div ngbAccordionCollapse>
						<div ngbAccordionBody>
							<ng-template>
                                <div class="row">

                                    <div class="col-lg-6 col-sm-12">

                                        <table class="table table-sm p-0 m-0">
                                            <tbody>
                                            <tr *ngFor="let p of impParties">
                                                <td class="entity-code"><span class="badge rounded-1 bg-secondary">{{p.entityCode}}</span></td>
                                                <td>
                                                    <div>{{p.importer.name}}</div>
                                                    <div class="small">{{p.importer.physicalAddress.city1}} {{p.importer.physicalAddress.state}}</div>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>

                                    </div>

                                    <div class="col-lg-6 col-sm-12">
                                        <table class="table table-sm p-0 m-0">
                                            <tbody>
                                            <tr *ngFor="let p of midParties">
                                                <td class="entity-code"><span class="badge rounded-1 bg-secondary">{{p.entityCode}}</span></td>
                                                <td>
                                                    <div>{{p.manufacturer.name}}</div>
                                                    <div class="small">{{p.manufacturer.address.city1}} {{p.manufacturer.address.country}}</div>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>

                                    </div>
                                </div>
							</ng-template>
						</div>
					</div>
					
				</div>
			</div>
			
		</div>
		
	`,
	styles:[`

        .template-header table,
        .template-header {
            --bs-table-bg: #535f6f;
            background-color: #535f6f;
			font-size: 20px;
        }

        .template-header {
            border-radius: 6px;
        }

		.acc-header {
			font-weight: bold;
			margin-right: 6px;
		}
        .accordion{
			--bs-accordion-bg: none;
            --bs-accordion-border-color: #ccc;
            --bs-accordion-border-width: 0px;
            --bs-accordion-active-color: #ccc;
		}
		.accordion-button:not(.collapsed){
			background-color: inherit;
		}

		.accordion-button{
			/*display: block;*/
		}


        .accordion-button:after {
            top: 12px;
            right: 12px;
            position: absolute;
			
        	margin-left: 0;
            margin-right:0.5em;
        }
		
        span.badge {
            font-size: 18px;
            width: 46px;
        }

        div.small {
            font-size: 8px;
        }

        td {
            vertical-align: middle;
        }

        td.entity-code {
            width: 30px;
        }

        @media (min-width: 576px) {

        }
	`]
})
export class PartiesData implements OnInit{
	
	@Input()
	template!:TemplateDto;
	
	@Input()
	isf!:TemplateSubmisionRequest;
	
	@Output()
	isfChange:EventEmitter<TemplateSubmisionRequest> = new EventEmitter();
	
	private importerCodes	= ["IM","CN","BY","ST"];
	private midCodes 		= ["SE","LG","CS","MF"];
	
	impParties:Array<TemplatePartyDto> = [];
	midParties:Array<TemplatePartyDto> = [];
	//mfParties:Array<TemplatePartyDto> = [];
	
	partyHeaderCollapse:boolean = false;
	
	
	ngOnInit(): void {
	
		this.headerCheck();
		
		let e = this.template.parties.map((p) => p.entityCode);
		
		this.midCodes
			.filter((c) => !e.includes(c))
			.map((c) =>this.toMid(this.template.manufacturer,c))
			.forEach((c) => {
				//c.hts = c.hts || [];
				
				this.midParties.push(c);
				
				/*
				if(c.entityCode == 'MF'){
					
					let hts = <PartyHts10Dto>{hts: "", country:c.manufacturer.address.country};
					
					if(this.template.hts && this.template.hts != "" && this.template.hts != null){
						hts.hts = this.template.hts;
					}
					
					c.hts = Array.from([hts]);
					
					this.mfParties.push(c);
				}
				
				 */
			});
		
		this.importerCodes
			.filter((c) => !e.includes(c))
			.map((c) =>this.toImp(this.template.importer,c))
			.forEach((c) => this.impParties.push(c));
		
		this.template.parties
			.filter((p) => p.partyType == "CBP_MID")
			.forEach((p) => {
				this.midParties.push(p);
				//if(p.entityCode == 'MF'){this.mfParties.push(p);}
			});
		
		this.template.parties
			.filter((p) => p.partyType == "IMPORTER")
			.forEach((p) => this.impParties.push(p));
		
		
		//console.log(this.mfParties);
		
	}
	
	
	headerCheck(){
		this.partyHeaderCollapse = (window.innerWidth < 998)
	}
	
	
	
	@HostListener('window:resize', ['$event'])
	onResize(event: any) {
		this.headerCheck();
	}
	
	
	
	/**
	 *
	 * @param m
	 * @param code
	 * @private
	 */
	private toMid(m:ManufacturerData, code:string):TemplatePartyDto{
		return <TemplatePartyDto>{
			partyType: "CBP_MID",
			entityCode: code,
			manufacturer: m
		};
	}
	
	
	/**
	 *
	 * @param m
	 * @param code
	 * @private
	 */
	private toImp(m:ImporterDto, code:string):TemplatePartyDto{
		return <TemplatePartyDto>{
			partyType: "IMPORTER",
			entityCode: code,
			importer: m
		};
	}
}
